/* ---------------------------------------------------------------------------
   ws-product-gallery.js — WELLX mobile product gallery arrows
   ---------------------------------------------------------------------------
   Impact's product gallery ships no prev/next buttons on the media itself,
   only a follow-cursor affordance on desktop and page dots on mobile. This
   wires the two ws- arrow buttons to the carousel Impact already runs.

   It does NOT implement any slider logic. <media-carousel> extends
   ScrollCarousel, which exposes previous() and next(); both clamp at the
   first and last slide on their own (BaseCarousel.previousSlide/nextSlide
   use Math.max/Math.min when the element has no `loop` attribute, which the
   product gallery does not set). So there is no index maths here and no
   disabled state to keep in sync.

   Listening on document rather than binding per button is deliberate: Impact
   re-renders the gallery on variant change via <product-rerender>, which
   replaces these nodes. Delegation survives that with no observer.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.wsProductGalleryReady) {
    return;
  }
  window.wsProductGalleryReady = true;

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.ws-gallery-arrow');

    if (!arrow) {
      return;
    }

    var wrapper = arrow.closest('.product-gallery__media-list-wrapper');
    var carousel = wrapper && wrapper.querySelector('media-carousel');

    // Custom elements upgrade asynchronously; bail rather than throw if a tap
    // lands before media-carousel has been defined.
    if (!carousel || typeof carousel.next !== 'function') {
      return;
    }

    event.preventDefault();

    if (arrow.classList.contains('ws-gallery-arrow--prev')) {
      carousel.previous();
    } else {
      carousel.next();
    }
  });
})();
